import { combineReducers } from 'redux';

import consultaProcessoAdministrativo from './processosAdministrativos/reducer';

export default combineReducers({
	consultaProcessoAdministrativo,
});
